import { useMemo } from "react";

import { useDesignElementManager } from "@hooks/use-design-element-manager";
import { Checkbox } from "@shared/checkbox";

import {
  EFFICIENCY_OVER_TIME,
  SPEND_VS_REVENUE,
  type ExportSelection,
} from "./export-channel-insights-modal";

interface Props {
  column: {
    column_name: string;
    breakdowns: { key: string; value: string }[];
    spend: number;
  };
  exportSelection: ExportSelection;
  setExportSelection: (value: ExportSelection) => void;
}

export const ExportChannelRow = ({
  column,
  exportSelection,
  setExportSelection,
}: Props) => {
  const { designElementManager } = useDesignElementManager();

  const channel = useMemo(() => {
    const breakdowns = column.breakdowns || [];
    return breakdowns.map((e, idx) =>
      e.key === "Platform (Northbeam)" ? (
        <div
          key={`${idx}-${e.value}`}
          className="text-gray+1 flex items-center gap-2"
        >
          {designElementManager
            .getDesignElement(e.value)
            .getComponent({ size: "20px" })}
          {e.value}
          {idx < breakdowns.length - 1 && breakdowns.length > 1 ? " / " : ""}
        </div>
      ) : (
        <div key={`${idx}-${e.value}`}>
          {e.value}
          {idx < breakdowns.length - 1 && breakdowns.length > 1 ? " / " : ""}
        </div>
      ),
    );
  }, [column, designElementManager]);

  return (
    <>
      <div className="border-b border-gray-3 py-2 flex flex-row space-x-1 col-span-6">
        {channel}
      </div>
      <div
        className="w-full border-b border-l border-r border-gray-3 py-2 flex-center cursor-pointer hover:bg-cosmic-4 col-span-3"
        onClick={() =>
          setExportSelection({
            ...exportSelection,
            [column.column_name]: {
              ...exportSelection[column.column_name],
              [SPEND_VS_REVENUE]:
                !exportSelection[column.column_name][SPEND_VS_REVENUE],
            },
          })
        }
      >
        <Checkbox
          value={exportSelection[column.column_name][SPEND_VS_REVENUE]}
        />
      </div>
      <div
        className="w-full border-b border-gray-3 py-2 flex-center cursor-pointer hover:bg-cosmic-4 pl-4 col-span-3"
        onClick={() =>
          setExportSelection({
            ...exportSelection,
            [column.column_name]: {
              ...exportSelection[column.column_name],
              [EFFICIENCY_OVER_TIME]:
                !exportSelection[column.column_name][EFFICIENCY_OVER_TIME],
            },
          })
        }
      >
        <Checkbox
          value={exportSelection[column.column_name][EFFICIENCY_OVER_TIME]}
        />
      </div>
    </>
  );
};
